import React from 'react';
import Section from '../layout/Section';
import SectionTitle from '../ui/SectionTitle';
import FAQItem from '../ui/FAQItem';
import StaggerContainer from '../animations/StaggerContainer';
import { faqItems as faqData } from '../../data/faq';

export default function FAQSection() {
  return (
    <Section dark id="faq">
      <SectionTitle
        title="Questions fréquentes"
        subtitle="Tout ce que vous devez savoir sur XamXamBoutik"
        dark
      />
      <StaggerContainer className="max-w-3xl mx-auto space-y-3 sm:space-y-4">
        {faqData.map((item, i) => (
          <FAQItem key={i} item={item} index={i} />
        ))}
      </StaggerContainer>
    </Section>
  );
}
